import { useState } from "react";

import Date from "../../../../Core/Fields/Floating/Date";
import Input from "../../../../Core/Fields/Floating/Input";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab4 = ({
  IdData,
  AllowPurchaseInvoiceCreationWithoutPurchaseOrder,
  IsFrozen,
  AllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
  Disabled,
  BlockSupplier,
  HoldType,
  ReleaseDate
}) => {
  return (
   <div>
      <div className="px-2 py-3" style={{ background: 'white' }}>
        <div style={{ display: 'flex' }} >
          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Details</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>
               <div style={{ flex: 1 }}>
                 <label style={{ height: '10px' }}></label>
                  <Checkbox
              id="AllowPurchaseInvoiceCreationWithoutPurchaseOrder"
              label="Allow Purchase Invoice Creation Without Purchase Order"
              value={
                AllowPurchaseInvoiceCreationWithoutPurchaseOrder?.AllowPurchaseInvoiceCreationWithoutPurchaseOrder ||
                false
              }
               disabled={true}
              onChange={(val) =>
                AllowPurchaseInvoiceCreationWithoutPurchaseOrder?.setAllowPurchaseInvoiceCreationWithoutPurchaseOrder?.(
                  val
                )
              }
            />

                </div>

              <div style={{ flex: 1 }}>
                 <label style={{ height: '10px' }}></label>
                 <Checkbox
              id="AllowPurchaseInvoiceCreationWithoutPurchaseReceipt"
              label="Allow Purchase Invoice Creation Without Purchase Receipt"
              value={
                AllowPurchaseInvoiceCreationWithoutPurchaseReceipt?.AllowPurchaseInvoiceCreationWithoutPurchaseReceipt ||
                false
              }
               disabled={true}
              onChange={(val) =>
                AllowPurchaseInvoiceCreationWithoutPurchaseReceipt?.setAllowPurchaseInvoiceCreationWithoutPurchaseReceipt?.(
                  val
                )
              }
            />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

              <div style={{ flex: 1 }}>
                 <label style={{ height: '10px' }}></label>
                   <Checkbox
              id="IsFrozen"
              label="Is Frozen"
               disabled={true}
              value={IsFrozen?.IsFrozen || false}
              onChange={(val) => IsFrozen?.setIsFrozen?.(val)}
            />



                </div>
                 <div style={{ flex: 1 }}>
                   <label style={{ height: '10px' }}></label>
                 <Checkbox
              id="Disabled"
              label="Disabled"
              value={Disabled?.Disabled || false}
              onChange={(val) => Disabled?.setDisabled?.(val)}
               disabled={true}
            />
                </div>
              </div>


            </div>
          </div>

          <div className="col-md-6 px-2">
            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
              <div style={{ display: 'flex', gap: '15px' }}>
                <div style={{ flex: 1 }}>
                  <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Block Supplier</p>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '15px' }}>

                <div style={{ flex: 1 }}>
                  <label style={{ height: '19px' }}></label>
                  <Checkbox
              id="BlockSupplier"
              label="Block Supplier"
              value={BlockSupplier?.BlockSupplier || false}
              onChange={(val) => BlockSupplier?.setBlockSupplier?.(val)}
              disabled={true}
            />

                </div>
                {BlockSupplier?.BlockSupplier ? (
                  <>
                   <div style={{ flex: 1 }}>
                   <Input
                    style={{
                      height: "30px",
                    }}
                    label="Hold Type"
                    value={HoldType.HoldType}
                    readOnly
                  />
                 



                </div>
                <div style={{ flex: 1 }}>
                  <Input
                type="date"
                  id="ReleaseDate"
                  label="Release Date"
                  style={{
                    height: "30px",
                    border: ReleaseDate.Error ? "1px solid red" : "",
                  }}
                  value={ReleaseDate.ReleaseDate}
                  onChange={(e) => ReleaseDate.setReleaseDate(e.target.value)}
                  readOnly
                />
                </div>
                  </>
                ) : null}
              </div>




            </div>
          </div>
        </div>
         <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >

          <div className="col-md-12">
            <div className='' style={{ height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
             <ActivityCard doctype="Supplier" docname={IdData} />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Tab4;
